<template>
  <div class="card">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-body">
          <div class="p-6 p-md-5" v-if="!userType">
            <h2 class="card-title text-center mb-4">
              {{ $t("signup.user_type.select_title") }}
            </h2>
            <p class="text-center mb-5">
              {{ $t("signup.user_type.select_description") }}
            </p>

            <div class="d-flex flex-column gap-4">
              <div class="option-card">
                <button
                  class="btn btn-lg btn-outline-primary w-100 mb-2"
                  @click="selectUserType('company')"
                >
                  {{ $t("signup.user_type.company.button") }}
                </button>
                <p class="text-muted small">
                  {{ $t("signup.user_type.company.description") }}
                </p>
              </div>
              <div class="option-card">
                <button
                  class="btn btn-lg btn-outline-primary w-100 mb-2"
                  @click="selectUserType('private')"
                >
                  {{ $t("signup.user_type.private.button") }}
                </button>
                <p class="text-muted small">
                  {{ $t("signup.user_type.private.description") }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-else
            class="d-flex justify-content-center flex-column flex-md-row text-center"
          >
            <span>{{ $t("signup.user_type.selection_prefix") }} </span>
            <span v-if="userType === 'private'" class="px-1">{{
              $t("signup.user_type.selected_private")
            }}</span>
            <span v-else class="px-1">{{
              $t("signup.user_type.selected_company")
            }}</span>
            <button class="btn btn-link btn-sm m-0 p-1">
              <FontAwesomeIcon icon="rotate-left" @click="resetUserType" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";
import { useI18n } from "vue-i18n";
import { useValidators } from "@/composables/useValidators";

const props = defineProps<{
  userType: "private" | "company" | undefined;
  handleUpdateUserType: (
    userType: "private" | "company" | undefined
  ) => void | Promise<void>;
}>();

// Returned rather than just called: Vue attaches a `.catch()` to whatever a click handler
// returns (`callWithAsyncErrorHandling`). LTSignupFlow's callback awaits `updateQuery`, so
// returning its promise routes a rejection to the app's error handler instead of leaving an
// unhandled rejection.
const selectUserType = (type: "private" | "company") =>
  props.handleUpdateUserType(type);

const resetUserType = () => props.handleUpdateUserType(undefined);

// Form validation for userType
const { t } = useI18n();
const { required } = useValidators(t);
const state = computed(() => ({
  userType: props.userType,
}));

const rules = {
  userType: { required },
};

// The result is unused here; the call registers this step's validation with the parent
// flow's `v$` through vuelidate's provide/inject chain. `<script setup>` instances are
// closed, so binding it would only add an unused name.
useVuelidate(rules, state);
</script>
